import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../../store/actions'
import { NavLink } from 'react-router-dom'
import Logo from '../../logos/trapink'
import Nav from '../../nav'
import Promo from '../../promo'
import IconPhone from '../../icons/phone'

function mapStateToProps(state) {
  return { page: state.pageSlugData[0], pages: state.pagesData };
}

const mapDispatchToProps = (dispatch) => {
  const {fetchPageBySlug,fetchPages} = actions;
  return {
    fetchPageBySlug: bindActionCreators(fetchPageBySlug, dispatch),
    fetchPages: bindActionCreators(fetchPages, dispatch),
  }
}

class SiteHeader extends Component {
  componentWillMount() {
    this.props.fetchPages({'exclude': '61', 'orderby': 'menu_order', 'order': 'asc'});
    this.props.fetchPageBySlug('home');
  }

  render() {
    const { pages, page } = this.props

    if (!page || !pages) { return false }

    const {promo_banner_link_text, promo_banner_text, add_promo_banner_toggle} = page.acf

    let promoEl

    if (add_promo_banner_toggle) {
      promoEl = <Promo message={promo_banner_text} link={promo_banner_link_text}  />
    }

    return (
      <div className="app-header__container">
        {promoEl}
        <header className="app-header">
          <NavLink className="app-header__logo-link" to="/">
            <Logo className="app-header__logo" />
          </NavLink>
          <a className="app-header__link phone" href="tel:+19417301223">
            <IconPhone />
          </a>
          <Nav pages={ this.props.pages } />
        </header>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps)(SiteHeader);



// WEBPACK FOOTER //
// ./src/components/headers/site-header/index.js